module.exports = __webpack_public_path__ + "r-v3/img/eraser_white.f09f4cd1.svg";